import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-center mb-x5" }
const _hoisted_4 = ["innerHTML"]

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { ref } from 'vue';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import useBooleanToggle from '@/shared/useBooleanToggle';
import { useTermsAndConditions } from '@/shared/checkout/useTermsAndConditions';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutTermsAndConditions',
  props: {
    getTerms: null
  },
  setup(__props: any) {

const props = __props as {
    getTerms:() => Promise<string>
}



const labels = useBlockLabels();
const { accept, showValidationError } = useTermsAndConditions();
const { isToggled, toggle } = useBooleanToggle();

const termsAndConditions = ref('');

const openDialog = async() => {
    toggle();
    if (!termsAndConditions.value) {
        termsAndConditions.value = await props.getTerms();
    }
};

return (_ctx: any,_cache: any) => {
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_InputCheckbox, {
        modelValue: _unref(accept),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(accept) ? (accept).value = $event : null)),
        name: "termsAndConditions",
        "show-errors": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_unref(labels).paymentSelectTermsAndConditions) + " ", 1),
            (_unref(labels).paymentTermsAndConditionsLink)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "c-magic-line c-magic-line--underline text-dusty-grey inline",
                  onClick: _withModifiers(openDialog, ["prevent"])
                }, _toDisplayString(_unref(labels).paymentTermsAndConditionsLink), 9, _hoisted_2))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_Transition, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_unref(showValidationError))
          ? (_openBlock(), _createElementBlock("div", {
              key: _unref(showValidationError),
              class: "text-roman mt-x1 ml-30",
              role: "alert"
            }, _toDisplayString(_unref(labels).paymentTermsAndConditionsValidationError), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(BaseDialog, {
      "is-open": _unref(isToggled),
      class: "fixed inset-0 p-x5 mx-auto z-1 bg-white max-w-850 pt-x5 flex flex-col sm:relative sm:inset-auto sm:h-auto sm:w-screen-80 sm:max-h-screen-80",
      onClose: _unref(toggle)
    }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(labels).paymentTermsAndConditionsTitle), 1),
        (termsAndConditions.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "o-scrollbar-y pr-x5 -mr-x5",
              innerHTML: termsAndConditions.value
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open", "onClose"])
  ]))
}
}

})